export enum BANNER_GROUP_CODE {
  mainPageSlider = 'MainPageSlider',
  mainPageSliderAlt = 'MainPageSliderAlt',
  catalogBanner = 'CatalogBanner',
  cartBanner = 'CartBanner',
  orderBanner = 'OrderPaymentStepBanner',
  promotionBanner = 'PromotionBanner',
}
